<template>
    <div class="basic-uj">
        <h4>{{$t('UJ.welcome')}}</h4>
        <h1>{{$t('UJ.commonDesc')}}</h1>
        <p class="desc">{{$t('UJ.question')}}</p>
        <ul class="basic-list checked-list">
            <li>
                <h2>{{$t('UJ.QTitle1')}}</h2>
                <p>{{$t('UJ.QDesc1')}}</p>
            </li>
            <li>
                <h2>{{$t('UJ.QTitle2')}}</h2>
                <p>{{$t('UJ.QDesc2')}}</p>
            </li>
            <li>
                <h2>{{$t('UJ.QTitle3')}}</h2>
                <p>{{$t('UJ.QDesc3')}}</p>
            </li>
        </ul>

        <div class="primary-btn">
            <a class="btn solid-btn" :href="linkToSignUp">{{$t('UJ.startBTN')}}</a>
            <p class="little-hint">{{$t('UJ.totalTimeCostHint')}}</p>
            <a class="login" href="/accounts/login/?next=/en/user-journey/">{{$t("UJ.haevAccount")}}</a>
        </div>
    </div>
</template>

<style lang="scss" scoped>
</style>

<script>
export default {
    name: "UJStart",
    props: {
        ppbApi: {}
    },
    data() {
        return {
            linkToSignUp: `/accounts/register/?user_journey=1&next=${encodeURIComponent(
                "/user-journey/?index=1"
            )}`
        };
    },
    mounted() {},
    methods: {}
};
</script>



// WEBPACK FOOTER //
// src/components/userJourney/UJStart.vue